import { Link } from '@mui/material';
import { get } from 'lodash';
import { Link as RouterLink } from '@tanstack/react-router';

export const DisplayName = ({ row, contactIdField, nameField }) => {
    const contactId = get(row, contactIdField);
    const name = get(row, nameField);

    return (
        <Link
            component={RouterLink}
            to={`/contacts/${contactId}/`}
            underline="hover"
            fontWeight={500}
            id={contactId}
        >
            {name}
        </Link>
    );
};
